import React from "react";
import { createStyles, Fab, withStyles, WithStyles } from "@material-ui/core";
import { faLock, faLockOpen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";

import Can from "../../../../../../components/Can";
import colors from "../../../../../../theme/colors";
import { getIsFrozen } from "../../../../../../modules/factoringClient";
import { openDialog } from "../../../../../../modules/ui";
import ConfirmFreezeDialog, {
  CONFIRM_FREEZE_DIALOG_VARIANT
} from "../dialogs/ConfirmFreezeDialog";
import ConfirmUnfreezeDialog, {
  CONFIRM_UNFREEZE_DIALOG_VARIANT
} from "../dialogs/ConfirmUnfreezeDialog";

const styles = () =>
  createStyles({
    freezeButton: {
      boxShadow:
        "0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)",
      background: colors.orange,
      color: colors.white,
      textTransform: "none"
    },
    unfreezeButton: {
      boxShadow:
        "0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)",
      background: colors.green,
      color: colors.white,
      textTransform: "none"
    },
    icon: {
      marginRight: 6
    }
  });

interface Props extends WithStyles<typeof styles> {}

const FreezeReceivablesButton = ({ classes }: Props): JSX.Element => {
  const dispatch = useDispatch();
  const isFrozen = useSelector(getIsFrozen);

  const openFreezeDialog = (): void => {
    dispatch(openDialog(CONFIRM_FREEZE_DIALOG_VARIANT));
  };

  const openUnfreezeDialog = (): void => {
    dispatch(openDialog(CONFIRM_UNFREEZE_DIALOG_VARIANT));
  };

  return (
    <>
      {isFrozen ? (
        <Can
          perform="admin-factor_client-profile:Unfreeze"
          yes={(): JSX.Element => (
            <Fab
              variant="extended"
              size="medium"
              className={classes.unfreezeButton}
              onClick={openUnfreezeDialog}
            >
              <FontAwesomeIcon
                icon={faLockOpen}
                size="sm"
                color={colors.white}
                className={classes.icon}
              />
              Unfreeze Receivables
            </Fab>
          )}
        />
      ) : (
        <Can
          perform="admin-factor_client-profile:Freeze"
          yes={(): JSX.Element => (
            <Fab
              variant="extended"
              size="medium"
              className={classes.freezeButton}
              onClick={openFreezeDialog}
            >
              <FontAwesomeIcon
                icon={faLock}
                size="sm"
                color={colors.white}
                className={classes.icon}
              />
              Freeze Receivables
            </Fab>
          )}
        />
      )}
      <ConfirmFreezeDialog />
      <ConfirmUnfreezeDialog />
    </>
  );
};

export default withStyles(styles)(FreezeReceivablesButton);
